export default "__VITE_ASSET__Cl2r4VtI__"